import { Component, ChangeDetectionStrategy } from '@angular/core';
import { EditProfileFormComponent } from '../../../user-profile/components/edit-profile-form/edit-profile-form.component';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'app-user-settings',
  templateUrl: './user-settings.template.html',
  styleUrls: ['./user-settings.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, EditProfileFormComponent],
})
export class UserSettingsComponent {
  public lang = this.translocoService.getActiveLang();

  constructor(private readonly translocoService: TranslocoService) {}
}
